




// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import OrderChecking from "@/components/checking/orderChecking.vue";

@Component({
  name: "CheckPage",
  components: {OrderChecking},
})
export default class CheckPage extends Vue {}
